import { Fragment, useState, useRef } from 'react';
import { urlWithParams } from '../../../services/Util';
import { Link, useHistory } from 'react-router-dom';

export default function Email({
	onClick,
	pageId,
	id: buttonId,
	value,
	valueIsSet = false,
	successMessage,
	formTitle,
	emailInputPlaceholder,
	messageInputPlaceholder,
	formSubmitButtonLabel,
	children,
}) {
	const [isEmailSent, setIsEmailSent] = useState(false);
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');

	const { __ } = wp.i18n;
	const history = useHistory();

	const emailInput = useRef();
	const messageInput = useRef();

	if ((!value || !value.length) && !valueIsSet) {
		return false;
	}

	function onEmailUpdate(e) {
		setEmail(e.target.value);
	}

	function onMessageUpdate(e) {
		setMessage(e.target.value);
	}

	function doSendEmail() {
		const { current: emailCurrent } = emailInput;

		if (!email.length) {
			emailCurrent.focus();
			return false;
		}

		const { current: messageCurrent } = messageInput;

		if (!message.length) {
			messageCurrent.focus();
			return false;
		}

		window.jQuery
			.post(window.social_link_pages.admin_ajax, {
				action: 'social_link_pages_send_email',
				email: email,
				message: message,
				page_id: pageId,
				button_id: buttonId,
				_wpnonce: document.getElementById('social_link_pages_wpnonce').value,
			})
			.always((response) => {
				setIsEmailSent(true);

				setTimeout(() => {
					history.push(urlWithParams({ m: '' }));
				}, 4000);
			});
	}

	return (
		<Link className="btn" to={urlWithParams({ m: 'email' })}>
			{children}
		</Link>
	);
}
